module.exports = _.extend({
  initialize: function () {
    _.bindAll(this, '_moveToPage', '_resetPrintable');

    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;

    INKIVE.ProjectFacade.on('design.added', this._resetPrintable);
    INKIVE.ProjectFacade.on('design.removing', this._resetPrintable);
  },

  open: function () {
    if (!this.orderPrintView) {
      const OrderPrintView = require('../../../ui/top-submenu/contents/order-print/view');

      this.orderPrintView = new OrderPrintView();
    }

    this.orderPrintView.show();
    INKIVE.EditorFacade.on('page.move_to', this._moveToPage);
  },

  close: function () {
    this.orderPrintView && this.orderPrintView.hide();
    INKIVE.EditorFacade.off('page.move_to', this._moveToPage);
    INKIVE.C.IS_MOBILE || _.delay(this._refreshActiveTab, 500);
  },

  imageQualityCheck: function (opts) {
    this.orderPrintView && this.orderPrintView.imageQualityCheck(opts);
  },

  toggleBleed: function (opts) {
    const { editor } = INKIVE.Tool.getInstance();
    const show = opts.show;

    if (this.orderPrintView) {
      this.orderPrintView.currentState = show ? 'toggleBleed' : '';
    }

    document.querySelectorAll('#workarea, #svgcontent>.main, #ik-grid-snap').forEach(node => {
      node.style.pointerEvents = show ? '' : 'none';
    });

    show && editor.canvas.runExtensions('generateNewBleed', {});
    show || editor.canvas.clearSelection();
    editor.canvas.runExtensions(show ? 'showBleedClipper' : 'hideBleedClipper', { keepDisabled: true });
    editor.canvas.runExtensions((show ? 'enableGuideLine' : 'disableGuideLine'), { keepVisible: true });
  },

  replaceImage: function (opts) {
    this.orderPrintView && this.orderPrintView.replaceImage(opts);
  },

  forceDownload: function (opts) {
    this.orderPrintView && this.orderPrintView.forceDownload(opts);
  },

  getBleed: function (opts) {
    return this.canvas.runExtensions('getBleedValues');
  },

  isProjectPrintable: function () {
    return new Promise((resolve, reject) => {
      if (_.isUndefined(this.printable)) {
        const desygnerApi = require('../../../factory/desygner-api');
        const isDesign = INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE;
        const url = isDesign
          ? 'brand/templates/'
          : 'brand/designs/';

        desygnerApi.get(url + INKIVE.C.BOOK.encodedId).then(_.bind(function (design) {
          this.printable = design && design.is_printable;
          resolve(this.printable);
        }, this));
      } else {
        resolve(this.printable);
      }
    });
  },

  _moveToPage: function () {
    const handler = this.orderPrintView[this.orderPrintView.currentState];

    if (handler) {
      handler({ show: false });
      INKIVE.EditorFacade.once('history.reload', function () {
        _.defer(function () {
          handler({ show: true });
        });
      });
    }
  },

  _refreshActiveTab: function () {
    const activeTab = INKIVE.Helpers.getActiveTab();

    if (activeTab) {
      const selector = '#tab' + activeTab.charAt(0).toUpperCase() + activeTab.slice(1);
      $('#tool-panel').find('[href=' + selector + ']').trigger('click');
    }
  },

  _resetPrintable: function () {
    this.printable = undefined;
  }
}, Backbone.Events);
